import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { delay, forkJoin, Subscription } from 'rxjs';
import { Identity, IdentityStorage } from 'storage-service-lib';
import {
  IGroupedTenantIdTokenUsage,
  TokenUsageService
} from '../../services/token-usage.service';

@Component({
  selector: 'app-manager-header',
  templateUrl: './app-manager-header.component.html',
  styleUrls: ['./app-manager-header.component.scss'],
  standalone: false,
})
export class AppManagerHeaderComponent implements OnDestroy, OnInit {
  @Input() title = ''; // Title passed dynamically

  identity!: Identity;
  private identitySubscription: Subscription;
  public monthlyTokenUsage?: IGroupedTenantIdTokenUsage;
  public tokenUsageLimit?: number;
  public tokenUsagePercentageValue = 0;

  constructor(
    private identityStorage: IdentityStorage,
    private router: Router,
    private tokenUsageService: TokenUsageService
  ) {
    this.identitySubscription = this.identityStorage
      .observe()
      .pipe(delay(250)) // Prevents UI jumping
      .subscribe((identity) => (this.identity = identity));
  }

  public getFirstDayOfNextMonth(locale = navigator.language) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);

    return firstDay.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  ngOnInit(): void {
    forkJoin({
      monthlyTokenUsage: this.tokenUsageService.getTokenUsageForDate(new Date().toISOString().slice(0, 7)),
      tokenUsageLimit: this.tokenUsageService.getTokenUsageLimit()
    }).subscribe(({ monthlyTokenUsage, tokenUsageLimit }) => {
      this.monthlyTokenUsage = monthlyTokenUsage;
      this.tokenUsageLimit = tokenUsageLimit.tokenUsageLimit;

      this.tokenUsagePercentage();
    });

  }

  private tokenUsagePercentage(): void {
    if (!this.tokenUsageLimit || this.tokenUsageLimit === 0) {
      return;
    }
    const percentage = (this.monthlyTokenUsage?.totalTokenUsage / this.tokenUsageLimit) * 100;
    this.tokenUsagePercentageValue = Math.min(Math.max(percentage, 0), 100);
  }

  ngOnDestroy(): void {
    this.identitySubscription.unsubscribe();
  }
}
